import WelcomeAdvisor from './src/App'

import { reactToCwp } from '../../../../common/react-utils'

// Adding condition her for setup redirect with query params
if (window.location.href.includes('#/setup')) {
  window.location.href = window.location.href.replace('#/setup', '/setup')
}

export default reactToCwp(WelcomeAdvisor)
